 <mat-form-field class="dropdown">
    <mat-label *ngIf="!selected" class="label">{{placeHolder}}</mat-label>
    <mat-select [(value)]="selected" disableOptionCentering="true" (selectionChange)="selectedItemChanged()" >
      <mat-option *ngFor="let option of options" [value]="option.country ? option.country : option.key ">{{option.country ? option.country : (option.value)  }}</mat-option>
    </mat-select>
  </mat-form-field>